import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/message';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getMessages(params: any) {
    return api.getMessages(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async adminpush(params: any) {
    return api.adminpush(params)
  }

  @Action
  async phrase(params: any) {
    return api.phrase(params)
  }

  @Action
  async addphrase(params: any) {
    return api.addphrase(params)
  }

  @Action
  async editphrase(params: any) {
    return api.editphrase(params)
  }

  @Action
  async getphrase(params: any) {
    return api.getphrase(params)
  }

  @Action
  async deletephrase(params: any) {
    return api.deletephrase(params)
  }
}
